import store from '../store'

import app from '../main'

import moment from "moment"
require('moment/locale/tr')

export const audit_functions = {

data() {
	return {
		
	};
},
methods:{

	mapInputfields()
	{
		let arr = this.$store.state.audit.selected_options
		this.$store.dispatch('audit/setListviewPreparing',true) 
		let parentsections = this.$store.state.audit.questionlist.parentsections
		
		let sections = []
		for(let parentsection of parentsections)
		{
			let section = this.getParentChildSections(parentsection,arr)
			sections.push(section)
			
		}
		this.$store.dispatch('audit/setListviewQuestionlist',sections) 
		setTimeout(()=>{
		this.$store.dispatch('audit/setListviewPreparing',false)
		},10) 
		//console.log(this.$store.state.audit.listview_questionlist)
	},
	mapInputfieldsWithoutLoader()
	{
		let arr = this.$store.state.audit.selected_options
		let parentsections = this.$store.state.audit.questionlist.parentsections
		
		let sections = []
		for(let parentsection of parentsections)
		{
			let section = this.getParentChildSections(parentsection,arr)
			sections.push(section)			
		}
		this.$store.dispatch('audit/setListviewQuestionlist',sections)
	},
	getParentChildSections(section,arr)
	{		
		let inputfields = this.getSectionInputfields(section.id,arr) 
		let options = this.$store.state.audit.questionlist.options
		for(let inputfield of inputfields)
		{
			inputfield.options = options
		}
		section.inputfields = inputfields
		section.child_sections = []

		let child_sections = this.$store.state.audit.questionlist.inputfieldsections.filter((item)=>{return item.parent_id == section.id})
		if(child_sections.length)
		{
			
			for(let child_section of child_sections)
			{
				let the_child_section = this.getParentChildSections(child_section,arr)
				section.child_sections.push(the_child_section)
			}
		}

		return section
	},
	getSectionInputfields(section_id,arr)
	{
		let inputfields = this.$store.state.evaluation.inputfields.filter((item)=>{return item.inputfieldsection_id == section_id})
		let final = []
		if(arr.includes("empty"))
		{
			final = inputfields.filter((item)=>{return !item.completion })
		}
		else if(!arr.length)
		{
			final = inputfields
		}
		else
		{
			for(let element of arr)
			{
				
				
					final = final.concat(inputfields.filter((item)=>{
						if(item.submissions.length)
						{
							return item.submissions[0].submission_option ==  element
						}
						
					}))
				
				
			}
		}
		return final
	},
	async getAndParseAuditData()
	{
		this.$store.dispatch('audit/setListviewPreparing',true) 
		let data = await this.generalApiGetWithoutLoader("auditor_audits/get_audit_data_questions/"+this.$route.params.audit_uuid) 
		
  		await store.dispatch('audit/setQuestionlist',data) 
  		console.log("getAndParseAuditData")
  		console.log(data)
  		let audit_inputfields_data = await this.generalApiGet("auditor_audits/get_audit_inputfields_data/"+this.$route.params.audit_uuid)
  		console.log(audit_inputfields_data)
		await store.dispatch('evaluation/setNullreasons',audit_inputfields_data.nullreasons) 
		await store.dispatch('evaluation/setCustomattributes',audit_inputfields_data.customattributes) 
		for(let condition of audit_inputfields_data.questionlist_conditions)
		{
			condition.conditions = await JSON.parse(condition.conditions)
			condition.outcome = await JSON.parse(condition.outcome)
		}
		await store.dispatch('evaluation/setQuestionlistConditions',audit_inputfields_data.questionlist_conditions) 
		await this.arrangeAuditInputfields(audit_inputfields_data)
		
		if(data.type=="same_question_pattern")
		{
			let inputfields = await store.state.evaluation.inputfields
			for(let item of inputfields)
			{
				item.columns = await data.columns
				item.options = await data.options
			}
			await store.dispatch('evaluation/setInputfields',inputfields)
		}
		//await console.log(store.state.evaluation.inputfields)
		this.$store.dispatch('audit/setListviewPreparing',false) 

	},
	getSectionQuestions(section_id)
	{
		let section = store.state.audit.questionlist.inputfieldsections.find((item)=>{return item.id == section_id})
		let child_sections = store.state.audit.questionlist.inputfieldsections.filter((item)=>{return item.parent_id == section_id})

		return{
			section:section,
			child_sections:child_sections,
		}
	},
	sortQuestions()
	{
		//store.dispatch('auth/setUserRoles',the_userroles) 
		let questionlist = store.state.audit.questionlist
		
		let parent_sections = questionlist.parent_sections
		for(let parent_section of parent_sections)
		{
			this.getSectionElements(parent_section.id)

		}


	},
	getSectionElements(parent_section_id)
	{
		let allsections = store.state.audit.questionlist.inputfieldsections
		let child_sections = allsections.filter((item)=>{return item.parent_id == parent_section_id})

		if(child_sections.length)
		{
			for(let section of child_sections)
			{
				this.getSectionElements(section.id)
			}
		}
	},
	async afterSubmitAuditInputData(response)
	{
			console.log(store.state.audit)
	      let inputfield = await this.checkSingleInputfieldCompletion(response.data)
			if(store.state.audit.questionlist.type=="same_question_pattern")
			{
				inputfield.columns = await store.state.audit.questionlist.columns
				inputfield.options = await store.state.audit.questionlist.options
			}
	      
	      await store.dispatch('evaluation/setInputfieldsUpdating',true)
	      let all_ind = await this.$store.state.evaluation.inputfields.findIndex((item)=>{return item.id == response.data.id})
	      let all_fields = await this.$store.state.evaluation.inputfields
	      all_fields[all_ind] = await inputfield
	      await this.checkQueslionlistConditions()
	      inputfield = await this.checkSingleInputfieldCompletion(inputfield)
	      console.log("afterSubmitAuditInputData")
	      console.log(store.state.audit)
	      
	      
	      all_fields[all_ind] = await inputfield

	      
	      await store.dispatch('evaluation/setInputfields',all_fields)
	      
	     
	      for(let item of all_fields)
	        {
	        	//await this.checkInputfieldConditions(item.id)
	        }
	       await this.calculateEvaluationProgress("first_init")
	      await store.dispatch('evaluation/setInputfieldsUpdating',false)
	},
	submitInputFieldAuditSubmission(formdata,data_id)
	{
		store.dispatch('evaluation/setInputfieldsUpdating',true)		
		this.generalSubmission(formdata,"audit/submit_inputfield_submission/"+data_id,this.afterSubmitAuditInputData)
		
	},
	
},
}